import ImageFirstSection from './ImageFirstSection'

export default ImageFirstSection
